// PWA Authentication Fix
// Handles auth state persistence and loading issues in PWA mode

export const pwaAuthFix = {
  // Clear any problematic cached auth data
  clearAuthCache: async () => {
    try {
      // Clear service worker caches that might have auth data
      if ('caches' in window) {
        const cacheNames = await caches.keys();
        for (const cacheName of cacheNames) {
          if (cacheName.includes('dynamic') || cacheName.includes('api')) {
            await caches.delete(cacheName);
            console.log('PWA Auth Fix: Cleared cache', cacheName);
          }
        }
      }
      
      // Clear localStorage auth issues
      const keysToRemove = [];
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key?.includes('supabase') && key?.includes('auth')) {
          keysToRemove.push(key);
        }
      }
      keysToRemove.forEach(key => localStorage.removeItem(key));
      
    } catch (error) {
      console.error('PWA Auth Fix: Failed to clear cache', error);
    }
  },

  // Force a hard refresh to clear any cached states
  forceRefresh: () => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then(registrations => {
        registrations.forEach(registration => {
          registration.unregister();
        });
        window.location.reload(true);
      });
    } else {
      window.location.reload(true);
    }
  },

  // Check if we're in PWA mode
  isPWAMode: () => {
    return window.matchMedia('(display-mode: standalone)').matches ||
           window.navigator.standalone ||
           document.referrer.includes('android-app://');
  },

  // Fix dashboard loading issues
  fixDashboardLoading: () => {
    if (pwaAuthFix.isPWAMode()) {
      // Add a small delay to allow auth state to settle
      return new Promise(resolve => {
        setTimeout(resolve, 1000);
      });
    }
    return Promise.resolve();
  }
};

export default pwaAuthFix;